// extracted by mini-css-extract-plugin
export var card = "_q4-0";
export var content = "_q4-2";
export var details = "_q4-3";
export var icon = "_q4-1";
export var iconBlue = "_q4-5";
export var iconBrand = "_q4-4";
export var iconGrayBlue = "_q4-6";
export var iconGreen = "_q4-7";
export var iconIndigo = "_q4-8";
export var iconOrange = "_q4-9";
export var iconPurple = "_q4-a";
export var iconRed = "_q4-b";
export var iconWarning = "_q4-c";